import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { APP_CONFIG } from '@core/constants/app-config.constants';
import { TPortalType } from '@core/enums/portal-type.enum';
import { TenantNameResolverService } from '@core/services/tenant-name-resolver.service';

@Component({
  templateUrl: 'redirect.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectComponent implements OnInit {
  appConfig = inject(APP_CONFIG);
  logoUrl = '../../../../assets/montage-logos/montage_logo_white.svg';

  constructor(private readonly tenantNameResolver: TenantNameResolverService, private readonly router: Router) {}

  ngOnInit(): void {
    const tenant = this.tenantNameResolver.resolveTenantName();
    this.router.navigate([tenant]);
  }
}
